<template>
    <!--formatter:off-->
    <div class="wrap" :style="wrapperStyle">
        <ResponseHeader v-if="!isWebView" :isPreview="false" />

        <div v-if="isLoading" class="loading_wrap">
            <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
        </div>

        <CoronaResponseResult
                v-if="showResult"
                :title="this.title"
                :is-pass="this.coronaCheckIsPass"
                :is-allow-edit="this.isAllowEdit"
                :is-web-view="this.isWebView"
                :need-notice-corona-response-result="this.needNoticeCoronaResponseResult"
                @editCoronaResponse="editCoronaResponse"
        />
        <div v-if="showSurveyEdit" class="content survey">
            <div class="tit_area">
                <p class="tit">{{title}}</p>
            </div>
            <div id="html" class="articleViewer">
                <p>{{surveyDesc}}</p>
            </div>
            <div class="after_tit_area">
                <div class="tit_bx">
                    <h2 class="tit">
                        <span class="txt">{{$t('SurveyResponseDefault_surveyInfo')}}<span class="txt_small">({{$t('SurveyResponseDefault_totalQuestionCount', {count: questions.length})}})</span></span>
                    </h2>
                </div>
                <ul class="case_lst">
                    <li>
                        <ul class="info_detail">
                            <li>
                                <span class="info_tit">{{$t('SurveyResponseState_responseTarget')}} :</span>
                                <span class="info_txt">{{receiverName}}</span>
                            </li>
                            <li>
                                <span class="info_tit">{{$t('SurveyResponseState_endDate')}} :</span>
                                <span class="info_txt">
                                <span class="time">{{endDateText}}</span>
                            </span>
                            </li>
                        </ul>
                    </li>
                </ul>
                <form action="#" onsubmit="return false">
                    <fieldset>
                        <legend>{{$t('SurveyResponseDefault_blind_surveyArea')}}</legend>
                        <ul class="survey_lst">
                            <li v-for="(question, index) in questions">
                                <div class="txt_box">
                                    <span class="num">{{index + 1}}.</span>
                                    <div class="txt">
                                        <p class="tit">{{question.title}}</p>
                                        <span v-if="question.desc" class="desc">{{question.desc}}</span>
                                        <nl2br v-if="question.questionDesc" tag="span" class="desc2" :text="question.questionDesc"/>
                                    </div>
                                </div>
                                <span v-for="option in question.options" class="check_box">
                                    <input type="checkbox" class="inp" :id="question.questionNo + '_' + option.answerNo"
                                           :checked="isCheckedOption({questionNo: question.questionNo, answerNo: option.answerNo})"
                                           @click="doCheckOption({questionNo: question.questionNo, answerNo: option.answerNo, isMultiCheck: question.isMultiCheck})"
                                    />
                                    <label class="lb" :for="question.questionNo + '_' + option.answerNo"><span class="txt">{{option.desc}}</span></label>
                                </span>
                            </li>
                        </ul>
                        <div class="btn_area">
                            <button type="submit" class="btn" @click="submit">{{$t('SurveyResponseDefault_submit')}}</button>
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    </div>
    <!--formatter:on-->
</template>

<script>
import Nl2br from 'vue-nl2br';
import responseApi from '@common/apis/survey/responseApi.js';
import moment from 'moment';
import {toDateFromISOFormat, toDate년월일Format, toResponseViewFormat} from '@/common/utils/date.js';
import ResponseHeader from '@/iamteacherpc/components/services/iamteacher/ResponseHeader.vue';
import {$showErrorPage} from '@common/utils/errorPage.js';
import SimpleErrorMessage from '@common/views/SimpleErrorMessage.vue';
import CoronaResponseResult from '@/iamteacherpc/components/response/CoronaResponseResult.vue';
import {START_DATE_OF_SCHOL} from '@/common/consts/corona.js';

export default {
        name: 'CoronaResponse',
        components: {
            Nl2br,
            ResponseHeader,
            CoronaResponseResult,
        },

        data() {
            return {
                isLoading: false,
                showResult: false,
                showSurveyEdit: false,
                survey: {},
                surveyDesc: this.$t('CoronaResponse_desc'),
                receiverName: '',
                endDateText: '',

                questions: [
                    ...this.getFixedQuestions(),
                ],
                pending: false,
            }
        },

        computed: {
            isWebView() {
                return this.$route.query.hasOwnProperty('isMasking');
            },

            wrapperStyle() {
                return this.isLoading ? {height: '100%'} : {};
            },

            title() {
                return this.$t('CoronaResponse_title', {date: toDate년월일Format(this.survey.startDate)});
            },

            isAfterPeriod() {
                const endDate = toDateFromISOFormat(this.survey.endDate);
                return Date.now() > endDate;
            },

            isAllowEdit() {
                const allowEditOption = this.survey.surveyOptions.find(option => option.optionType === 'ALLOW_EDIT');
                return !!(allowEditOption && allowEditOption.optionValue === "true");
            },

            coronaCheckIsPass() {
                return this.questions.every(question => {
                    return question.answers.length === 1 && question.answers[0].answerNo === '1';
                });
            },

            isAlreadyAnswer() {
                return this.survey.surveyReceivers[0].surveyAnswers.length !== 0;
            },

            /**
             * 진단결과 공개여부 (교육부 지침 학년별 등교일 일주일 전부터 공개)
             */
            needNoticeCoronaResponseResult() {
                const classType = this.survey.surveyReceivers[0].receiverOptions.find(option => option.optionType === 'FILTER_TAG').optionValue;
                return moment(this.survey.startDate).isAfter(moment(START_DATE_OF_SCHOL[classType], 'YYYY-MM-DD').subtract(7, 'days'));
            },
        },

        methods: {
            /**
             * 문항 체크 여부
             * @param questionNo
             * @param answerNo
             * @returns {boolean}
             */
            isCheckedOption({questionNo, answerNo}) {
                const question = this.questions.find(q => q.questionNo === questionNo);
                return question.answers.findIndex(a => a.answerNo === answerNo) !== -1;
            },

            /**
             * 문항 체크 동작시
             * @param questionNo
             * @param answerNo
             * @param isMultiCheck
             */
            doCheckOption({questionNo, answerNo, isMultiCheck}) {
                const question = this.questions.find(q => q.questionNo === questionNo);
                if (this.isCheckedOption({questionNo, answerNo})) {
                    question.answers.splice(question.answers.findIndex(a => a.answerNo === answerNo), 1);
                    return;
                }

                const selectedOption = question.options.find(o => o.answerNo === answerNo);
                if (isMultiCheck) {
                    if (selectedOption.isOnlyOne) {
                        question.answers = [selectedOption];
                        return;
                    }

                    if (question.answers.some(a => a.isOnlyOne)) {
                        question.answers = question.answers.filter(a => !a.isOnlyOne);
                    }
                    question.answers.push(selectedOption);
                }

                else {
                    question.answers = [selectedOption];
                }
            },

            /**
             * 제출하기
             * @returns {Promise<void>}
             */
            async submit() {
                if (this.pending) {
                    return;
                }

                if (!this.validateAnswer({questions: this.questions})) {
                    return;
                }

                try {
                    this.pending = true;
                    await responseApi.postSurveyAnswers({
                        surveyNo: this.survey.surveyNo,
                        request: this.makeSubmitRequest(),
                    });

                    window.scrollTo(0, 0);
                    this.showSurveyEdit = false;
                    this.isLoading = true;
                    await setTimeout(() => {
                        this.isLoading = false;
                        this.showResult = true;
                    }, 1000);
                } catch (err) {
                    window.alert(err.message);
                } finally {
                    this.pending = false;
                }
            },

            validateAnswer({questions}) {
                if (this.isAlreadyAnswer && !this.isAllowEdit) {
                    window.alert(this.$t('CoronaResponse_notAllowEdit'));
                    return false;
                }

                for (let i = 0; i < questions.length; i++) {
                    if (questions[i].answers.length === 0) {
                        window.alert(this.$t('CoronaResponse_pleaseAnswer', {number: i + 1}));
                        return false;
                    }
                }
                return true;
            },

            makeSubmitRequest() {
                const surveyReceiverNo = this.survey.surveyReceivers[0].surveyReceiverNo;
                const surveyAnswers = this.questions.map(question => {
                    return {
                        questionNo: question.questionNo,
                        answers: question.answers.map(answer => {
                            return {
                                answerNo: answer.answerNo,
                                answer: answer.desc,
                            };
                        })
                    };
                });

                return {
                    surveyReceiverNo,
                    surveyAnswers,
                }
            },

            async setInitSurvey() {
                try {
                    this.survey = await this.getRequestInfo();
                    this.receiverName = this.survey.surveyReceivers[0].receiverName;
                    this.endDateText = toResponseViewFormat(this.survey.endDate);
                } catch (e) {
                    if (e instanceof Error) {
                        console.log(e);
                        e.message = this.$t('common_scriptError');
                    }

                    $showErrorPage({component: SimpleErrorMessage, payload: {message: e.message}});
                }
            },

            /**
             * 응답화면 로드 시 필요한 초기정보
             * @returns {Promise<AxiosResponse<T>>}
             */
            async getRequestInfo() {
                let {surveyReferenceNo, r, serviceId, isMasking} = this.$route.query;
                isMasking = isMasking !== 'false';
                return await responseApi.getSurveyAnswer({surveyReferenceNo, receiverReferenceNo: r, provider: serviceId.toUpperCase(), isMasking: !!isMasking});
            },

            setAnswers() {
                const alreadySelectedAnswers = this.survey.surveyReceivers[0].surveyAnswers;
                alreadySelectedAnswers.forEach(answer => {
                    const question = this.questions.find(q => q.questionNo === answer.questionNo);
                    question.answers.push(question.options.find(o => o.answerNo === answer.answerNo + ''));
                });
            },

            editCoronaResponse() {
                window.scrollTo(0, 0);
                this.showSurveyEdit = true;
                this.showResult = false;
            },

            //자가진단 고정 질문
            getFixedQuestions() {
                return [
                    {
                        questionNo: '20201',
                        title: this.$t('CoronaResponse_2103_q1'),
                        questionDesc: this.$t('CoronaResponse_2103_q1_desc'),
                        isMultiCheck: false,
                        options: [
                            {answerNo: '1', desc: this.$t('CoronaResponse_2103_q1_a1')},
                            {answerNo: '2', desc: this.$t('CoronaResponse_2103_q1_a2')},
                        ],
                        answers: [],
                    },
                    {
                        questionNo: '20202',
                        title: this.$t('CoronaResponse_2103_q2'),
                        questionDesc: this.$i18n.locale === 'ko' ? this.$t('CoronaResponse_2103_q2_desc') : null,
                        isMultiCheck: false,
                        options: [
                            {answerNo: '1', desc: this.$t('CoronaResponse_2103_q2_a1')},
                            {answerNo: '2', desc: this.$t('CoronaResponse_2103_q2_a2')},
                        ],
                        answers: [],
                    },
                    {
                        questionNo: '20203',
                        title: this.$t('CoronaResponse_2103_q3'),
                        questionDesc: this.$t('CoronaResponse_2103_q3_desc'),
                        isMultiCheck: false,
                        options: [
                            {answerNo: '1', desc: this.$t('CoronaResponse_2103_q3_a1')},
                            {answerNo: '2', desc: this.$t('CoronaResponse_2103_q3_a2')},
                        ],
                        answers: [],
                    },
                ];
            },
        },

        async created() {
            await this.setInitSurvey();
            if (this.isAfterPeriod) {
                $showErrorPage({
                    component: SimpleErrorMessage,
                    payload: {message: this.$t('CoronaResponse_answerTimeExpired')},
                });
            }

            if (this.isAlreadyAnswer) {
                this.setAnswers();
                this.showResult = true;
                return;
            }

            this.showSurveyEdit = true;

            const {surveyNo, surveyReceivers} = this.survey;
            if (!surveyReceivers[0].readDate) {
                // 읽음처리 API는 응답을 기다리지 않음
                responseApi.patchSurveyReceiverRead({
                    surveyNo,
                    surveyReceiverNo: surveyReceivers[0].surveyReceiverNo,
                });
            }
        },
    };
</script>
